import React, { useState } from 'react';
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import withRouter from '../../Components/Common/withRouter';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { COMPANY_NAME, DEVELOPER_NAME } from '../../constants';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import logoLight from '../../assets/images/logo-light.png';
import { userLoginAction } from '../../actions/auth/action';

/**
 *
 * @param {*} props
 * @returns
 */
const Login = () => {
  //
  const history = useNavigate();
  const dispatch = useDispatch();

  //
  const userState = useSelector((state) => state.user || {});
  const { errorMsg } = userState || {};
  //
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // form validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required('Please enter your Email'),
      password: Yup.string().required('Please enter your Password'),
    }),
    onSubmit: (values) => {
      setIsLoading(true);
      const { email, password } = values || {};
      triggerApi({ email, password });
    },
  });

  // Api Call
  const triggerApi = async ({ email, password }) => {
    await userLoginAction({ input: { email, password } }, dispatch, history);
    setIsLoading(false);
  };

  document.title = 'Loyalty Admin | Login';

  return (
    <React.Fragment>
      <Container fluid>
        <Row className="border-bottom">
          <Col
            md="9"
            className="m-auto d-flex justify-content-between align-items-center py-4"
          >
            <Link to="/" className="logo">
              <img
                src="https://assets.danubehome.com/media/assets/svg-v2/logoEn.svg"
                alt="large logo"
                height="22"
              />
            </Link>
            {/* <div className="d-flex gap-3">
              <Button color="primary" outline className="shadow-none">
                Sign Up
              </Button>
            </div> */}
          </Col>
        </Row>
        <Row>
          <Col
            style={{ maxWidth: 600 }}
            className="position-absolute top-50 start-50 translate-middle"
          >
            <div className="px-2 pb-3 text-center">
              <h2 className="text-dark fw-bold">Welcome Back !</h2>
              <p className="text-dark">Please enter your account details</p>
            </div>
            {errorMsg && <Alert color="danger"> {errorMsg} </Alert>}
            <Card>
              <div className="p-5">
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                  action="#"
                >
                  <div className="mb-3">
                    <Label htmlFor="email" className="form-label text-dark">
                      Email
                    </Label>
                    <Input
                      autoComplete="off"
                      name="email"
                      size="md"
                      className="form-control"
                      placeholder="Enter email"
                      type="text"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email || ''}
                      invalid={
                        validation.touched.email && validation.errors.email
                          ? true
                          : false
                      }
                    />
                    {validation.touched.email && validation.errors.email ? (
                      <FormFeedback type="invalid">
                        {validation.errors.email}
                      </FormFeedback>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    {/* <div className="float-end">
                      <Link to="/forgot-password" className="text-dark">
                        Forgot password?
                      </Link>
                    </div> */}
                    <Label
                      className="form-label text-dark"
                      htmlFor="password-input"
                    >
                      Password
                    </Label>
                    <div className="position-relative auth-pass-inputgroup mb-3">
                      <Input
                        name="password"
                        size="md"
                        value={validation.values.password || ''}
                        type={showPassword ? 'text' : 'password'}
                        className="form-control pe-5"
                        placeholder="Enter Password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                          validation.touched.password &&
                          validation.errors.password
                            ? true
                            : false
                        }
                      />
                      {validation.touched.password &&
                      validation.errors.password ? (
                        <FormFeedback type="invalid">
                          {validation.errors.password}
                        </FormFeedback>
                      ) : null}

                      <button
                        className="btn btn-link position-absolute end-0 top-0  text-decoration-none text-muted shadow-none"
                        onClick={() => setShowPassword(!showPassword)}
                        type="button"
                        id="password-addon"
                      >
                        <i className="ri-eye-fill align-middle"></i>
                      </button>
                    </div>
                  </div>

                  <div className="form-check">
                    <Input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="auth-remember-check"
                    />
                    <Label
                      className="form-check-label text-dark"
                      htmlFor="auth-remember-check"
                    >
                      Remember me
                    </Label>
                  </div>

                  <div className="mt-4">
                    <Button
                      size="lg"
                      color="primary"
                      disabled={isLoading ? true : false}
                      className="w-100"
                      type="submit"
                    >
                      {isLoading ? (
                        <Spinner size="sm" className="me-2">
                          Loading...
                        </Spinner>
                      ) : null}
                      Sign In
                    </Button>
                  </div>

                  <div className="my-4">
                    I accept{' '}
                    <a href="#" className="text-info text-decoration-underline">
                      terms & conditions
                    </a>
                  </div>
                </Form>
              </div>
            </Card>
            <div className="d-flex justify-content-center align-items-center gap-3 fs-13">
              <Link
                to="/forgot-password"
                className="text-info text-decoration-underline"
              >
                Reset password
              </Link>
              |
              <Link className="text-info text-decoration-underline">
                Resend confirmation
              </Link>
              |
              <Link className="text-info text-decoration-underline">
                Unlock account
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default withRouter(Login);
